import React from 'react'

const Home = () => {
  return (
   <>
   <div className="img1 mt-3">
   
   </div>
   <div className="img2">
   
   </div>

  
   <div className="img3">
   
   </div>
 
   </>
  )
}

export default Home
